import { Component, OnInit, Input } from '@angular/core';
import { ReportBase } from '../report.base';
import { ReportsService } from '../../../../services';
import { ActivatedRoute } from '@angular/router';
import { CreditReport, Store, AppState } from '../../../../store';

@Component({
  selector: 'app-credit-report',
  templateUrl: './credit-report.component.html',
  styleUrls: ['./credit-report.component.css']
})
export class CreditReportComponent extends ReportBase implements OnInit {

  report: CreditReport;
  controls = [
    { name: 'name', type: 'text', title: 'Name' },
    { name: 'creditSpentDate', type: 'date', title: 'Date' },
    { name: 'teamGroup', type: 'text', title: 'Team' },
    { name: 'feeName', type: 'text', title: 'Fee' },
    { name: 'gender', type: 'select', title: 'Gender', options: [ { text: 'Male', value: 'm' }, { text: 'Female', value: 'f' } ] },
    { name: 'creditAddedBy', type: 'text', title: 'By' },
    { name: 'creditReason', type: 'text', title: 'Reason' },
    { name: 'spentCreditAmount', type: 'number', title: 'Credit' }
  ];

  constructor(
    public service: ReportsService,
    public store: Store<AppState>
  ) {
    super(service, store);
  }

  ngOnInit() {
    this.pullData('getCreditReportData');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/credit-report/credit-report.component.ts